<router-outlet></router-outlet>
<p>
  <mat-toolbar class="custom-toolbar">
    <span class="brand-logo">
      <img src="logo_UBA.png" class="logo">
      <span>.UBA</span>
    </span>
    <span class="app-title">Consulta de Código Único de Escuela (CUE)</span>
  </mat-toolbar>
</p>
<app-loading-spinner *ngIf="loading==true"></app-loading-spinner>

<section>
  <div class="selected-info" *ngIf="selectedSchool">
    <span style="width: 80%;">
      <h3>Cod.Unico de {{selectedSchool.nombre}}: {{selectedSchool.cue_anexo}}</h3>
      <p>
        <mat-icon>location_on</mat-icon>
        {{selectedSchool.domicilio}}
      </p>
    </span>
    <span style="width: 80%;">
      <p style="font-size:0.75em">
        Para copiar el CUE de tu colegio secundario, hacé click en el siguiente ícono
        <mat-icon [cdkCopyToClipboard]="selectedSchool.cue_anexo" style="cursor:pointer;">content_copy</mat-icon>
      </p>
    </span>
  </div>

  <div style="padding: 20px; display:flex; justify-content: space-between;flex-wrap: wrap;">
    <mat-form-field appearance="fill" style="width: 400px;">
      <mat-label>Seleccioná la Provincia...</mat-label>
      <mat-select [(ngModel)]="selectedProvincia" (selectionChange)="clearAll()">
        <mat-option *ngFor="let provincia of jurisdicciones" [value]="provincia" (click)="getPartidos(provincia)">
          {{provincia}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 400px;">
      <mat-label>Seleccioná el Partido...</mat-label>
      <mat-select [(ngModel)]="selectedPartido" [disabled]="!selectedProvincia" (selectionChange)="cleanFromPartidos()">
        <mat-option *ngFor="let partido of partidos" [value]="partido" (click)="getLocalidades(partido)">
          {{partido}}</mat-option>

      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 400px;">
      <mat-label>Seleccioná la localidad</mat-label>
      <mat-select [(ngModel)]="selectedLocalidad" [disabled]="!selectedPartido"
        (selectionChange)="cleanFromLocalidades()">
        <mat-option *ngFor="let localidad of localidades" [value]="localidad" (click)="getEscuelas()">
          {{localidad}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>



  <div class="schools-list-container">
    <h4 *ngIf="selectedProvincia && selectedPartido && selectedLocalidad">Seleccioná tu escuela de la lista</h4>
    <mat-selection-list role="list" [multiple]="false">
      <mat-list-option class="schoolListItem" *ngFor="let school of schools; let i=index" role="listitem"
        [value]="school.cue_anexo" (click)="setSelected(i)">
        {{school.nombre}} ({{school.domicilio}})
      </mat-list-option>
    </mat-selection-list>
  </div>

</section>